import { chartPointsFor } from "@/components/Measurements/charts/data";
import { measurementSeries } from "@/components/Measurements/charts/groups";
import {
    ChartRange,
    DEFAULT_CHART_RANGE,
    displayCutoffFor
} from "@/components/Measurements/charts/range";
import { PlanPeriod } from "@/components/Measurements/charts/series";
import { ChartConfig } from "@/components/Measurements/models/Category";
import { MeasurementEntry } from "@/components/Measurements/models/Entry";
import { MeasurementSeriesChart } from "@/components/Measurements/widgets/MeasurementSeriesChart";
import { OverallChange } from "@/components/Measurements/widgets/OverallChange";
import { WeightUnit } from "@/core/lib/weightUnit";
import React from "react";
import { useTranslation } from "react-i18next";

export interface WeightChartProps {
    weights: MeasurementEntry[],
    unit: WeightUnit,
    categoryUnit: string,
    range?: ChartRange,
    planPeriods?: PlanPeriod[],
    height?: number,
    /** Chart settings of the body weight category */
    chartConfig?: ChartConfig,
}

/**
 * Body weight over time: the same chart every other measurement gets, plus
 * the mean and the distance of each reading from the trend, which the weight
 * screens showed before body weight became a measurement.
 */
export const WeightChart = (
    { weights, unit, categoryUnit, range, planPeriods, height = 300, chartConfig = {} }:
    WeightChartProps,
) => {
    const [t] = useTranslation();

    // Entries can be stored in mixed units, so every value is converted
    // before anything is derived from it
    const series = measurementSeries(
        chartPointsFor(weights, unit, categoryUnit),
        displayCutoffFor(range ?? DEFAULT_CHART_RANGE),
        chartConfig,
    );

    return <>
        <MeasurementSeriesChart
            series={series}
            unit={t(`server.${unit}`)}
            height={height}
            planPeriods={planPeriods}
            showMean
            showVariance />
        <OverallChange series={series} unit={t(`server.${unit}`)} />
    </>;
};
